import { useSelector } from 'react-redux'
import { useMemo } from 'react'

const useParentQuestion = (question) => {
  const questions = useSelector((state) => state.questions)
  return useMemo(() => {
    for (const [index, parent] of questions.entries()) {
      if (parent.type !== 'expandable') {
        continue
      }

      if (parent.content?.find((sq) => sq.id === question.id)) {
        return [parent, index]
      }
    }
    return [null, null]
  }, [questions, question])
}

export default useParentQuestion
